import { FormLogin } from '../../content/login/form/model';
import { demoLogin } from '../../../common/constants/demo';

export const demoModeCredentials: FormLogin = {
    login: demoLogin,
    password: 'Sqwerty1'
};
